import { compose } from 'redux';

import { reduxForm } from 'redux-form';

import { withIntl } from 'HOC/withIntl';
import generateInitialLanguageValues from 'utilities/generateInitialLanguageValues';
import getDefaultLanguageRequiredFieldsErrors from 'utilities/getDefaultLanguageRequiredFieldsErrors';
import shouldSubmit from 'utilities/shouldSubmit';

import InfoForm from '../../components/InfoForm';

import { addInfoRequest } from '../../services/actions';
import { forms, requiredInfoFields, localizableInfoFields, defaultInfoValues } from '../../services/config';

const form = forms.addInfoForm;
const initialLangValues = generateInitialLanguageValues();

const validate = (values, { intl }) =>
    getDefaultLanguageRequiredFieldsErrors(values, requiredInfoFields, intl.formatMessage({ id: 'error.required' }));

const onSubmit = (data, dispatch, { categoryId, intl }) => {
    const confirmMessage = intl.formatMessage({ id: 'alert.submit.warn' });
    if (shouldSubmit(data, localizableInfoFields, confirmMessage)) {
        dispatch(addInfoRequest(form, categoryId, data));
    }
};
export default compose(
    withIntl,
    reduxForm({
        form,
        initialValues: {
            ...initialLangValues,
            ...defaultInfoValues,
        },
        validate,
        onSubmit,
    }),
)(InfoForm);
